<template>
<section class="pt-8 pt-md-5 pb-8 pb-md-14">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <form class="mb-6" @submit.prevent="save">
                    <p class="mb-6 text-danger" v-for="error in errors.__all__">{{ error }}</p>
                    <div class="form-group">
                        <div class="col">
                            <h1 class="mb-0 fw-bold">Order payout</h1>
                            <p class="mb-6 text-muted">
                                {{ $state.context.currency_symbol }}{{ $state.context.available_affiliate_amount }}
                                is available to withdraw your income!
                            </p>
                        </div>
                        <label class="form-label" for="amount">USDT amount:</label>
                        <div class="input-group mb-3">
                            <span class="input-group-text" id="basic-addon1">
                                {{ $state.context.currency_symbol }}</span>
                            <input type="number" min="20" value="20" :max="parseInt($state.context.available_affiliate_amount)"
                                   class="form-control" id="amount" v-model="form.amount"
                                   placeholder="Enter the amount. Minimum $20, maximum $2000 per order" aria-describedby="basic-addon1" /><br>
                            <div clear="both" />
                        </div>
                        <small class="form-text text-danger" v-for="error in errors.amount">{{ error }}</small>
                    </div>
                    <div class="form-group mb-3">
                        <label class="form-label">Network:</label>
                        <div class="btn-group w-100" role="group">
                            <input type="radio" class="btn-check" name="network" id="network-trc20" value="trc20" v-model="form.network">
                            <label class="btn btn-outline-primary" for="network-trc20">TRC20 (Tron)</label>
                            <input type="radio" class="btn-check" name="network" id="network-erc20" value="erc20" v-model="form.network">
                            <label class="btn btn-outline-primary" for="network-erc20">ERC20 (Ethereum)</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="address">{{ form.network === 'erc20' ? 'Ethereum' : 'Tron' }} address:</label>
                        <input type="text" class="form-control" :class="{'is-invalid': errors.address}" id="address"
                               :placeholder="form.network === 'erc20' ? 'Enter your Ethereum address (0x...)' : 'Enter your Tron address (T...)'" v-model="form.address">
                        <small class="form-text text-danger" v-for="error in errors.address">{{ error }}</small>
                    </div>
                    <p>
                        Your request for withdrawal of funds is processed 3-5 working days!
                    </p>
                    <button class="btn w-100 btn-primary" type="submit" :disabled="disabled">
                        Order
                    </button>
                </form>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import { NotifyMixin } from '@/mixins'
import { displayErrors } from "utils/string"

export default {
    mixins: [NotifyMixin],
    data() {
        return {
            errors: {},
            form: {
                network: 'trc20'
            },
            disabled: true
        }
    },
    methods: {
        save() {
            this.errors = {}
            this.disabled = true
            this.$services.Payout().save(this.form).then(resp => {
                this.errors = resp.body.errors || {}
                if (resp.body.state) {
                    this.successNotify({ message: "Successful" });
                } else {
                    displayErrors(resp, this);
                }
            }).catch(resp => {
                displayErrors(resp, this);
            }).finally(() => {
                this.disabled = false
            })
        }
    },
    watch: {
        'form.amount'(val, old) {
            this.disabled = val < 20
        }
    }
}
</script>
